import CardCommon from '@/pages/opinion/components/CardCommon';
import PlatformTitle from '@/pages/opinion/widgets/GameStorePlate/components/PlatformTitle';
import React from 'react';
import MetacriticScoreTrendBox from '../../widgets/ScoreTrendsPcConsole/MetacriticScoreTrendBox';
import VerticalScoreBox from '@/pages/opinion/widgets/GameStorePlate/components/VerticalScoreBox';
import { Col, Row } from 'tea-component';
import OpenCriticScoreTrendBox from '../../widgets/ScoreTrendsPcConsole/OpenCriticScoreTrendBox';
import useFeedsDetail from '../../hooks/useFeedsDetail';
import './CommonPlate.scss';

export default function CommonPlate({
  scoreLoading,
  timelineLoading,
  timeline,
  filter,
  ringData,
  dataKeys,
  channel,
  channelName,
}: {
  scoreLoading: boolean;
  timelineLoading: boolean;
  timeline: any;
  ringData: any;
  filter: any;
  dataKeys: Array<string>;
  channel: string;
  channelName: string;
}) {
  const { operations } = useFeedsDetail({ filter, channel });

  return (
    <CardCommon
      className="common-plate-wrapper"
      title={
        <PlatformTitle
          channelName={channel}
          title={channelName}
          iconTextMargin={6}
          size={16}
        ></PlatformTitle>
      }
      operations={operations}
    >
      <Row className="common-plate-box">
        <Col span={6}>
          <CardCommon contentCard loading={scoreLoading} loadingHeight={303}>
            <VerticalScoreBox
              title="Lifetime Reviews"
              channel={channel}
              hasEmptyImg
              hasEmptyTitle
              dataKeys={dataKeys}
              showHeader={false}
              size={32}
              data={ringData || {}}
            ></VerticalScoreBox>
          </CardCommon>
        </Col>
        <Col span={18}>
          <CardCommon contentCard loading={timelineLoading} loadingHeight={303}>
            {channel === 'metacritic' ? (
              <MetacriticScoreTrendBox
                platformData={timeline || []}
                filterParams={filter}
                height={275}
              ></MetacriticScoreTrendBox>
            ) : (
              <OpenCriticScoreTrendBox
                platformData={timeline || []}
                filterParams={filter}
                height={275}
              ></OpenCriticScoreTrendBox>
            )}
          </CardCommon>
        </Col>
      </Row>
    </CardCommon>
  );
}
